import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { DeleteButton, SaveButton, Toolbar } from 'react-admin';
import CancelButton from '../../Components/CancelButton';
import useProductSaveWithLabels from './useProductSaveWithLabels';

export interface ProductToolbarProps {
  disableDelete?: boolean;
  mode: 'create' | 'edit';
}

export default function ProductToolbar({
  disableDelete = false,
  mode,
}: ProductToolbarProps): ReactElement {
  const onSuccess = useProductSaveWithLabels(mode);

  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Box>
        <SaveButton mutationOptions={{ onSuccess }} type="button" />
        <CancelButton sx={{ marginLeft: '2em' }} />
      </Box>
      {disableDelete ? null : <DeleteButton />}
    </Toolbar>
  );
}
